// extracted by mini-css-extract-plugin
export default {"content":"App_content__b5cg3"};